import { Comment, Transition } from '@extrahorizon/javascript-sdk';
import { QueryParameters } from 'hooks/useSearchParameters';
import { Params } from 'react-router-dom';
import { CurrentUserData } from './user';
import { HourFormat, UnitType } from './generic';

export type Note = Comment & {
  name?: string;
};

export interface TableInput {
  pageParam: number;
  filters: QueryParameters;
  currentUser?: CurrentUserData;
  limit?: number;
  params: Readonly<Params<string>>;
  config: TableConfig;
}

export interface SchemasInformation {
  [schemaName: string]: { transitions?: Transition[] };
}

export interface TableConfig {
  queryKey: string;
  dataFieldNames?: {
    [key: string]: string;
  };
  defaultFilters?: QueryParameters;
  defaultSort?: string;
  refetchInterval?: number;
  groupId?: string;
}

export const DocumentsToApprove = {
  privacyPolicy: 'privacy_policy',
  termsOfUse: 'terms_of_use',
  medicalProfessionalAgreement: 'medical_professional_agreement',
};

export interface DocumentToApproveConfiguration {
  url: string;
  version: string;
}

export interface DocumentToApprove {
  key: string;
  isNew: boolean;
  version: string;
  hasApproved: boolean;
  url: string;
}

export enum MfaType {
  Totp = 'totp',
  RecoveryCodes = 'recoveryCodes',
}

export interface PatientIdProps {
  patientId?: string;
}

export interface DocumentIdProps {
  documentId?: string;
}

export interface CallBackProps {
  callback?: () => void;
}

export interface ConfigurationEnabled {
  enabled: boolean;
}

export interface LabelValueProps {
  label: string;
  value?: string;
}
export interface MeasurementWeightUnitsProps {
  weight?: number;
  unitSystem?: UnitType;
}

export interface MeasurementHeightUnitsProps {
  height?: number;
  unitSystem?: UnitType;
}

export interface FdaAllowedDeviceModel {
  model: string;
  label: string;
}

export interface FormatDateProps {
  timestamp: number | Date | string;
  formatWithTime?: boolean;
  timeWithSeconds?: boolean;
  specificHourFormat?: HourFormat;
}

export interface ApiTaskResult {
  success?: boolean;
  id?: string;
}

export interface ApiTaskAffectedRecords {
  affectedRecords: number;
}
